function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.434,5.976a5.976,5.976,0,0,0-11.952,0H0V20.169A3.735,3.735,0,0,0,3.735,23.9H17.181a3.735,3.735,0,0,0,3.735-3.735V5.976ZM10.458,2.241a3.739,3.739,0,0,1,3.735,3.735H6.723A3.739,3.739,0,0,1,10.458,2.241Zm8.217,17.928a1.5,1.5,0,0,1-1.494,1.494H3.735a1.5,1.5,0,0,1-1.494-1.494V8.217H4.482v1.867a1.12,1.12,0,0,0,2.241,0V8.217h7.47v1.867a1.12,1.12,0,1,0,2.241,0V8.217h2.241Z",
  transform: "translate(0 0)"
});

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.916,
    height: 23.904,
    viewBox: "0 0 20.916 23.904"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Cart.39e438c3.svg";
export { SvgCart as ReactComponent };